import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  AUTH_TYPE_CHECK_SUCCESS,
  AUTH_TYPE_CHECK_FAILURE,
  LOGIN_RESET,
} from './types';

const authType = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [AUTH_TYPE_CHECK_SUCCESS]: (_, { payload }) => payload.authType,
  [AUTH_TYPE_CHECK_FAILURE]: () => null,
  [LOGIN_RESET]: () => null,
});

const isNewlyAssociated = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [AUTH_TYPE_CHECK_SUCCESS]: (_, { payload }) => payload.isNewlyAssociated,
  [AUTH_TYPE_CHECK_FAILURE]: () => false,
  [LOGIN_RESET]: () => false,
});

const DEFAULT_ASSOCIATION = {
  moka: { email: '', phone: '' },
  hermes: { email: '', phone: '' },
};
const accountAssociation = createReducer(DEFAULT_ASSOCIATION, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [AUTH_TYPE_CHECK_SUCCESS]: (_, { payload }) => payload.association,
  [AUTH_TYPE_CHECK_FAILURE]: () => DEFAULT_ASSOCIATION,
  [LOGIN_RESET]: () => DEFAULT_ASSOCIATION,
});

export default combineReducers({
  authType,
  isNewlyAssociated,
  accountAssociation,
});
